import { Program, ProgramDetail } from "./model/Program";
import ProgramEvents from "./ProgramEvents";
import { AppAction } from "../../root/AppAction";

// 定義
export interface ProgramStore {
    programList: Program[];
    allProgramList: ProgramDetail[];
    isLoading: boolean;
    isUpdateProgram: boolean;
    isSuccessUpdateProgram: boolean;
    isFailedUpdateProgram: boolean;
    errorMessage: string;
}

// 初期値
const initialStore: 
ProgramStore = {
    programList: [],
    allProgramList: [],
    isLoading:false,
    isUpdateProgram: false,
    isSuccessUpdateProgram: false,
    isFailedUpdateProgram: false,
    errorMessage: ""
};

// 実行
export default function programList(state: ProgramStore = initialStore, action: AppAction) {
    switch (action.type) {
        case ProgramEvents.GetLearningProgramStarted:
            return {
                ...state,
                isLoading: true
            };

        case ProgramEvents.GetLearningProgramComplete:
            return {
                ...state,
                programList: action.programList,
                isLoading: false,
                errorMessage: ""
            };
            
        case ProgramEvents.GetAllProgramStarted:
            return {
                ...state,
                isLoading: true,
                allProgramList: []
            };

        case ProgramEvents.GetAllProgramComplete:
            return {
                ...state,
                isLoading: false,
                allProgramList: action.allProgramList,
                errorMessage: ""
            };

        case ProgramEvents.UpdateProgramStarted:
            return {
                ...state,
                isUpdateProgram: true,
                isSuccessUpdateProgram: false,
                isFailedUpdateProgram: false,
                isLoading: true,
                allProgramList: [],
                errorMessage: ""
            };

        case ProgramEvents.UpdateProgramComplete:
            return {
                ...state,
                isUpdateProgram: false,
                isSuccessUpdateProgram: true,
                isFailedUpdateProgram: false,
                isLoading: false,
                allProgramList: action.allProgramList,
                errorMessage: ""
            };
        case ProgramEvents.UpdateProgramFailed:
            return {
                ...state,
                isUpdateProgram: false,
                isSuccessUpdateProgram: false,
                isFailedUpdateProgram: true,
                isLoading: false,
                errorMessage: action.error
            };

        // プログラムにエピソード・関連Videoを追加
        case ProgramEvents.AddVideoToProgram:
            return {
                ...state
            };
        case ProgramEvents.AddVideoToProgramComplete:
            return {
                ...state,
                allProgramList: state.allProgramList.map(el => {
                    return el.id === action.program.id
                        ? action.program
                        : el;
                }),
            };

        default:
            return state;
    }
}
